import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { SharedDesktopModule } from '@brightside-web/shared/desktop';
import { BrightsideUiModule } from '@brightside/brightside-ui';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { SurveyQuestionnaireService } from '../survey-questionnaire.service';

@Component({
    selector: 'brightside-web-survey-abandoned',
    templateUrl: './survey-abandoned.component.html',
    styleUrls: ['./survey-abandoned.component.scss'],
    imports: [CommonModule, SharedDesktopModule, BrightsideUiModule, TranslateModule]
})
export class SurveyAbandonedComponent {

  private _surveyQuestionnaireService = inject(SurveyQuestionnaireService)

  constructor(private _router: Router) {}

  handleSurveyAbandonedDone(): void {
    this._surveyQuestionnaireService.backToHomeCalled();
  }
}
